import actions from './subscriptionsActions'
import mutations from './subscriptionsMutations'

export default {
  namespaced: true,
  actions,
  mutations
}